// Service's central-chat realm prefixes legacy IDs during history migration.
// Strip only our own realm; unrelated explicit IDs must remain distinct.
export const canonicalChatAgentId = (value) => String(value || '').trim().replace(/^service-playemp:/, '');
export const normalizedChatAgentName = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
export const chatAgentIdentityKey = (agent) => {
  const id = canonicalChatAgentId(agent?.id);
  const name = normalizedChatAgentName(agent?.name);
  return id ? `id:${id}` : (name ? `name:${name}` : 'support');
};

export const sameChatAgent = (left, right) => {
  const leftId = canonicalChatAgentId(left?.id);
  const rightId = canonicalChatAgentId(right?.id);
  if (leftId && rightId) return leftId === rightId;
  const name = normalizedChatAgentName(left?.name);
  return Boolean(name && name === normalizedChatAgentName(right?.name));
};

export const buildSupportAgentRows = (configuredAgents, agentUnread) => {
  const rows = [];
  for (const agent of Array.isArray(configuredAgents) ? configuredAgents : []) {
    if (!agent || agent.enabled === false || !String(agent.name || '').trim()) continue;
    if (rows.some(row => sameChatAgent(row, agent))) continue;
    rows.push({
      id: String(agent.id || '').trim(), name: String(agent.name).trim(),
      title: agent.title || 'Support Agent', avatar_url: agent.avatar_url || '',
      unread: { count: 0, lastMessage: '', lastMessageAt: '' },
    });
  }
  for (const item of Array.isArray(agentUnread) ? agentUnread : []) {
    const count = Math.max(0, Number(item?.unread_count) || 0);
    if (!count) continue;
    const agent = { id: String(item.agent_id || '').trim(), name: String(item.agent_name || 'Support Team').trim() };
    const exactMatches = rows.filter(row => chatAgentIdentityKey(row) === chatAgentIdentityKey(agent));
    const matches = exactMatches.length ? exactMatches : rows.filter(row => sameChatAgent(row, agent));
    // A name-only row can join a uniquely identified agent, never two namesakes.
    let row = matches.length === 1 ? matches[0] : null;
    if (!row) {
      row = { ...agent, title: item.agent_title || 'Support Agent', avatar_url: item.avatar_url || '',
        unread: { count: 0, lastMessage: '', lastMessageAt: '' } };
      rows.push(row);
    }
    row.unread.count += count;
    const date = Date.parse(item.last_message_at || '') || 0;
    if (!row.unread.lastMessage || date >= (Date.parse(row.unread.lastMessageAt) || 0)) {
      row.unread.lastMessage = item.last_message || '';
      row.unread.lastMessageAt = item.last_message_at || '';
    }
    if (!row.avatar_url) row.avatar_url = item.avatar_url || '';
  }
  if (!rows.length) rows.push({ id: 'support-team', name: 'Support Team', title: 'Live Chat Agent',
    avatar_url: '', unread: { count: 0, lastMessage: '', lastMessageAt: '' } });
  return rows.sort((a, b) => b.unread.count - a.unread.count
    || (Date.parse(b.unread.lastMessageAt) || 0) - (Date.parse(a.unread.lastMessageAt) || 0));
};
